import React from 'react';
import classNames from 'classnames';

function ProductInfoTableRow({
  label,
  value,
  valueTestId,
  priority,
  dataTestId,
}: {
  label: string;
  value: string | React.JSX.Element;
  valueTestId?: string;
  priority?: boolean;
  dataTestId?: string;
}) {
  return (
    <tr className="border-b border-gray-300" data-testid={dataTestId}>
      <td
        className={classNames('px-3 py-2', {
          'font-bold': priority,
        })}
      >
        {label}
      </td>
      <td
        className={classNames('text-right px-3 py-2', {
          'font-bold': priority,
        })}
        data-testid={valueTestId}
      >
        {value}
      </td>
    </tr>
  );
}

export default ProductInfoTableRow;
